import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './MunimIntroScreen.module.css'

const CAPABILITIES = [
    { title: 'Salary', sub: 'Gross, net, deductions sab' },
    { title: 'Attendance', sub: 'LWP, leaves, late marks' },
    { title: 'PF & ESI', sub: 'Compliance, deductions' },
    { title: 'FnF & Advance', sub: 'Exit, loans, recovery' },
    { title: 'Payslips', sub: 'Padhna, bhejana, disputes' },
    { title: 'Commission', sub: 'Slab, target, category' },
]

const MunimAvatar = () => {
    return (
        <div className={styles.avatarWrap}>
            <div className={styles.avatarRing}>
                <div className={styles.avatarInner}>
                    <span className={styles.avatarLetter}>M</span>
                </div>
            </div>
            <div className={styles.badgeNew}>
                <span className={styles.badgeText}>NEW</span>
            </div>
        </div>
    )
}

const NameBlock = () => (
    <div className={styles.nameBlock}>
        <p className={styles.nameMain}>
            MUNIM <span className={styles.nameJi}>ji</span>
        </p>
        <p className={styles.fullForm}>Master Utility for Numbers, Insights &amp; Management</p>
    </div>
)

const Tagline = () => (
    <p className={styles.tagline}>
        "Pehle Munim register mein likhta tha.
        <br />
        Ab <span className={styles.taglineAccent}>MUNIM ji</span> aapke phone mein hai."
    </p>
)

const Divider = () => <div className={styles.divider} />

const CapsLabel = () => (
    <p className={styles.capsLabel}>Yeh sab puchh sakte hain aap</p>
)

const CapsGrid = () => {
    const [visibleCount, setVisibleCount] = useState(0)

    useEffect(() => {
        let count = 0
        const timer = setInterval(() => {
            count += 1
            setVisibleCount(count)
            if (count >= CAPABILITIES.length) clearInterval(timer)
        }, 100)
        return () => clearInterval(timer)
    }, [])

    return (
        <div className={styles.capsGrid}>
            {CAPABILITIES.map((cap, i) => (
                <div
                    key={i}
                    className={`${styles.capPill} ${i < visibleCount ? styles.capPillVisible : ''}`}
                >
                    <span className={styles.capDot} />
                    <div>
                        <p className={styles.capTitle}>{cap.title}</p>
                        <p className={styles.capSub}>{cap.sub}</p>
                    </div>
                </div>
            ))}
        </div>
    )
}

const LanguageStrip = () => (
    <div className={styles.langStrip}>
        <p className={styles.langText}>
            Hindi ya English — <span className={styles.langAccent}>dono mein poochho.</span>
        </p>
        <p className={styles.langText}>
            <span className={styles.langAccent}>"PF kaise calculate hota hai?"</span> — bilkul sahi jawab milega.
        </p>
    </div>
)

const MunimIntroScreen = () => {
    const navigate = useNavigate()
    const containerRef = useRef(null)

    const handleDismiss = () => {
        localStorage.setItem('munim_intro_seen', '1')
        navigate('/payroll/ask-munim-ji')
    }

    useEffect(() => {
        const el = containerRef.current
        if (!el) return
        requestAnimationFrame(() => {
            el.classList.add(styles.screenVisible)
        })
    }, [])

    return (
        <div className={styles.screen} ref={containerRef}>
            <div className={styles.content}>
                <MunimAvatar />
                <NameBlock />
                <Tagline />
                <Divider />
                <CapsLabel />
                <CapsGrid />
                <LanguageStrip />

                <button
                    type="button"
                    className={styles.ctaBtn}
                    onClick={handleDismiss}
                >
                    MUNIM ji se poochho →
                </button>

                <button
                    type="button"
                    className={styles.skipBtn}
                    onClick={handleDismiss}
                >
                    Baad mein dekhenge
                </button>

                <p className={styles.footerNote}>Yeh screen dobara nahi aayegi</p>
            </div>
        </div>
    )
}

export default MunimIntroScreen